module.exports = __webpack_public_path__ + "img/icon_dropdown.77702655.svg";